import React from 'react'
import './loading.css'
const Loading = () => {
  return (
    <div className="loading__container">
        <div class="dots"></div>
    </div>
  )
}

export default Loading